import React, { useCallback, useEffect, memo } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Input, {
  DatePickerComponent,
  ExtraInputComponent,
  SelectComponent,
} from "../../FilterInput";

import { yupResolver } from "@hookform/resolvers/yup";

import { setTicketFilter } from "../../../../store/ticketsOperatorArea/actions";

import { useForm } from "react-hook-form";
import schema from "./filterValidation";

import "./style.scss";
const optionsPersonalInformation = [
  { value: "document", label: "Document" },
  { value: "phone", label: "phone" },
  { value: "email", label: "E-mail" },
];

function FilterComponent() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { mainTheme } = useSelector((state) => state.Layout);

  const { register, handleSubmit, errors, setValue, getValues } = useForm({
    resolver: yupResolver(schema),
  });

  const filter = useSelector((state) => state.TicketsOperatorArea.filter);
  const isOpen = useSelector((state) => state.TicketsOperatorArea.showFilter);

  const { skills, agents } = useSelector(
    (state) => state.TicketsOperatorArea.forms
  );

  const handleSubmitForm = useCallback(
    (data) => {
      dispatch(setTicketFilter(data));
    },
    [dispatch]
  );

  useEffect(() => {}, [errors]);

  return (
    <div className={`filter-component ${mainTheme} ${!isOpen && "hidden"}`}>
      <div className="d-flex flex-row justify-content-between w-100">
        <h5>{t("Ticket Filter")}</h5>
        <ErrorForms />
      </div>

      <form
        className="content-filter"
        onSubmit={handleSubmit(handleSubmitForm)}
      >
        <div className="content-filter-input">
          <Input
            label={t("Protocol")}
            name="protocol"
            type="text"
            placeholder={t("Enter the protocol")}
            required
            innerRef={register}
            error={errors.protocol?.message}
            defaultValue={getValues("protocol") || filter.protocol}
          />
        </div>
        <div className="content-filter-input">
          <Input label={t("Skills")} required>
            <SelectComponent
              name="skills_id"
              options={skills}
              isMulti
              placeholder={t("Select skills") + "..."}
              error={errors.skills?.value?.message}
              register={() => register({ name: "skills_id" })}
              onChange={(value) => {
                setValue("skills_id", value);
              }}
              defaultValue={getValues("skills_id") || filter.skills_id}
            />
          </Input>
        </div>
        <div className="content-filter-input">
          <Input label={t("Agent")} required>
            <SelectComponent
              name="agents_id"
              options={agents}
              placeholder={t("Select agent") + "..."}
              isClearable
              register={() => register({ name: "agents_id" })}
              onChange={(value) => {
                setValue("agents_id", value);
              }}
              error={errors.agent?.value?.message}
              defaultValue={getValues("agents_id") || filter.agents_id}
            />
          </Input>
        </div>
        <div className="content-filter-input">
          <Input
            label={t("Client")}
            name="client"
            type="text"
            placeholder={t("Enter customer name")}
            required
            innerRef={register}
            error={errors.client?.message}
            defaultValue={getValues("client") || filter.client}
          />
        </div>
        <div className="content-filter-input">
          <Input label={t("Personal information")}>
            <ExtraInputComponent
              name="personal_information"
              type="text"
              placeholder={t("Enter personal information")}
              options={optionsPersonalInformation}
              register={register}
              error={errors.personal_information}
              defaultValueTypes={
                getValues("personal_information.types") ||
                filter.personal_information?.types
              }
              defaultValue={
                getValues("personal_information.value") ||
                filter.personal_information?.value
              }
              onChangeSelect={(value) => {
                setValue("personal_information.types", value);
              }}
            />
          </Input>
        </div>
        <div className="content-filter-input">
          <Input label={t("Date")} required>
            <DatePickerComponent
              name="date"
              placeholderText={t("Date")}
              register={() => register({ name: "date" })}
              error={errors.date}
              onChange={(value) => {
                setValue("date", value);
              }}
              defaultValue={getValues("date") || filter.date}
            />
          </Input>
        </div>

        <div className="content-buttons-input">
          <SubmitButton label={t("Search")} />
        </div>
      </form>
    </div>
  );
}

export default memo(FilterComponent);

const SubmitButton = memo(({ label }) => {
  const status = useSelector((state) => state.TicketsOperatorArea.status);

  const isDisabled = status.table.loading;

  return (
    <button
      type="submit"
      className="btn btn-primary"
      disabled={isDisabled}
      style={{
        width: 71,
      }}
    >
      {isDisabled ? (
        <div className="spinner-border spinner-border-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        label
      )}
    </button>
  );
});

const ErrorForms = memo(() => {
  const status = useSelector((state) => state.TicketsOperatorArea.status.forms);
  const { t } = useTranslation();

  return (
    <>
      {status.error && (
        <div
          title={t(
            "Sorry! something went wrong, please contact our support team"
          )}
        >
          <i className="fa fa-exclamation-triangle text-danger mr-2" />
        </div>
      )}

      {status.loading && (
        <div>
          <i className="bx bx-loader bx-spin text-primary mr-2" />
        </div>
      )}
    </>
  );
});
